module.exports = __webpack_public_path__ + "img/left02.ac58b8bd.webp";